//import './assets/main.css'
import './assets/app.css'
import '@vuepic/vue-datepicker/dist/main.css';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import resource from '@/resource/api_resource-plugin.js'
import user from '@/resource/user-plugin.js'
import language from '@/resource/language-plugin.js'
import VueDatePicker from '@vuepic/vue-datepicker';
import { store } from '@/store/index.js'

if (!String.prototype.formatAssociative) {
	String.prototype.formatAssociative = function() {
		//"use strict";
		let str = this.toString();
		if (arguments.length) {
			let t = typeof arguments[0];
			let key;
			let args = ("string" === t || "number" === t) ?
				Array.prototype.slice.call(arguments)
				: arguments[0];

			for (key in args) {
				str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
			}
		}

		return str;
	};
}
const app   = createApp(App)
app.component('VueDatePicker', VueDatePicker);
//app.use(language)

app.use(VueAxios, axios);
app.use(store)
app.use(user);
app.use(resource);
app.use(language);

/*router.push({
	name: "test",
	route: "test",
	component: () => import('@/views/SignInView.vue')
});*/
app.use(router);


if(user.isAuth()){
	user.refreshPrivileges();
}
app.mount('#app')

/*

location /api/ {
	rewrite ^/api^/ /$1 break;
proxy_pass http://localhost:8080/;
	}*/
